import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { DesignTemplate } from '../models';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StandardDesignTemplateService {

  private path = '/standard_design_templates';

  constructor(private http: AlloxApiService) { }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new DesignTemplate(obj))
    );
  }

  public post(item: DesignTemplate) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: DesignTemplate) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }
}
